import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { filter, includes } from 'lodash';
import { environment } from 'environments/environment';
import { ShowStoryService } from '../show/show.service';
import { Story } from '../interfaces/story';
import { FirebaseService } from 'app/services/firebase.service';

@Injectable()
export class StoriesService {
  stories = [];
  allStories = [];
  fetchedStories = [];
  searchBy: string;
  isLoading;
  updateInterval;
  isListComponentShowing = false;
  displayNewBookInHeader = false;
  private baseUrl = environment.API;
  private storiesUrl = `${this.baseUrl}/stories/`;

  constructor(
    private http: HttpClient,
    private storyService: ShowStoryService,
    private firebaseService: FirebaseService
  ) {}

  search(search) {
    this.searchBy = search;
    if (!search) {
      this.stories = this.allStories;
      return;
    }

    this.stories = filter(this.allStories, story => {
      return includes(story.title.toLowerCase(), search.toLowerCase());
    });
  }

  get(url = this.storiesUrl) {
    this.isLoading = true;
    this.http.get(url).subscribe(data => {
      this.fetchedStories = this.fetchedStories.concat(data['results']);
      if (data['next']) {
        this.get(data['next']);
      } else {
        this.isLoading = false;
        this.allStories = [...this.fetchedStories];
        this.search(this.searchBy);
        this.updateStories();
        this.firebaseService.userProperties({
          story_count: this.allStories.length,
        });
      }
    });
  }

  update() {
    const designingStories = this.allStories.filter(
      story => ['new', 'designing'].indexOf(story.state) >= 0
    );
    if (designingStories.length) {
      designingStories.forEach(story => {
        this.storyService.load(story).subscribe((storyData: Story) => {
            this.allStories[
              this.allStories.findIndex(item => item.id === storyData.id)
            ] = storyData;
             if (storyData.state === 'published') {
               this.firebaseService.logEvent('story_publish', {
                 story_id: storyData.id,
                 project_id: storyData.project
               });
             }

            designingStories.splice(
              designingStories.findIndex(item => item.id === storyData.id),
              1
            );
          if (!designingStories.length) {
            this.search(this.searchBy);
            this.updateStories();
          }
        });
      });
    }
  }

  fetchStories() {
    this.fetchedStories = [];
    this.isLoading = true;
    this.get();
  }

  compareUpdate(existed, fetched) {
    return JSON.stringify(existed) === JSON.stringify(fetched);
  }

  updateStories() {
    if (this.isListComponentShowing) {
      this.fetchedStories = [];
      setTimeout(() => this.update(), 2000);
    }
  }

  clear() {
    this.allStories = [];
    this.search('');
    clearInterval(this.updateInterval);
  }

  deleteStory(id) {
    const url = `${this.baseUrl}/stories/${id}/`;
    clearInterval(this.updateInterval);

    this.http.delete(url).subscribe(() => {
      this.allStories = filter(this.allStories, story => {
        return story.id !== id;
      });
      this.search(this.searchBy);
    });
  }
}
